/* eslint-disable eqeqeq */
import {
  faEdit,
  faEllipsisVertical,
  faEye,
  faPaperPlane,
  faSync,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useCallback, useState } from "react";
import { useParams } from "react-router-dom";
// import SubContractorDelete from "./SubContractorDelete";
import SubContractorDetailsPopup from "./SubContractorDetailsPopup";
import CustomTooltip from "../../../common/CustomTooltip";
import { Button, Dropdown, Modal } from "react-bootstrap";
import Spin from "../../../common/Spin";
import { API, fileUpload, get } from "../../../../config";
import { toast } from "react-toastify";
import SubContractorDelete from "./SubContractorDelete";
import AdditionalDocumentEmailModal from "../../../common/AdditionalDocumentEmailModal";
import {
  formatAccountNumber,
  formatBSBNumber,
  formatedAddress,
  formatSubcontractorName,
} from "../../../common/Misc";
import PrintButton from "../../../common/PrintButton";

const SubContractorActionButton = ({
  id,
  handleDelete,
  ProjectReadOnly,
  toggleSingleSyncOptionModal,
  xeroConnection,
  email,
  fetchContractors,
  is_invited,
  ProjectData,
  used,
  record,
}) => {
  const [showDelete, setShowDelete] = useState(false);
  const [showView, setShowView] = useState(false);
  const [showTemplate, setShowTemplate] = useState(false);
  const [trustType, setTrustType] = useState(null);

  const [showInvite, setShowInvite] = useState(false);
  const [loading, setLoading] = useState(false);
  const params = useParams();
  const projectId = params?.project_id;
  const [files, setFiles] = useState([]);

  // eslint-disable-next-line no-unused-vars
  const [mailLoading, setMailLoading] = useState(false);
  const [mailData, setMailData] = useState(false);
  const [showSendEmail, setShowSendEmail] = useState(false);

  // eslint-disable-next-line no-unused-vars
  const fetchContractorMail = useCallback(async (id, trust_type = "") => {
    if (id) {
      try {
        setLoading(true);
        const { data } = await get(
          `${API.CONTRACTOR_DETAILS}/mail?id=${id}&trust_type=${
            trust_type == 0 ? "0" : trust_type ? trust_type : trustType
          }`
        );
        setShowSendEmail(false);
        setMailData(data?.data);
        data?.message && toast.success(data?.message);
        setLoading(false);
      } catch (error) {
        if (error?.response?.data?.errors) {
          setLoading(false);
          Object.keys(error?.response?.data?.errors).forEach((key) => {
            toast.error(error?.response?.data?.errors[key][0]);
          });
        } else {
          setLoading(false);
          toast.error(error?.message);
        }
      }
    }
    // eslint-disable-next-line
  }, []);

  const toggleShowModal = () => {
    setShowView(!showView);
  };

  const toggleShowInvite = () => {
    setShowInvite(!showInvite);
  };

  const toggleTemplateModal = (trust_type) => {
    if (showTemplate) {
      setTrustType(null);
    } else {
      setTrustType(trust_type);
    }
    setShowTemplate(!showTemplate);
  };

  const handleInvite = async () => {
    try {
      setLoading(true);
      const { data } = await get(`${API.CONTRACTOR_INVITE}/${id}`);
      setLoading(false);
      toast.success(data?.message);
      toggleShowInvite();
      fetchContractors();
    } catch (e) {
      setLoading(false);
      return null;
    }
  };

  const toggleDeleteModal = () => {
    setShowDelete(!showDelete);
  };

  const handleSendEmail = async (id, trust_type) => {
    if (showSendEmail) {
      setFiles([]);
      setTrustType(null);
    } else {
      setTrustType(trust_type);
      await fetchContractorMail(id, trust_type);
    }
    setShowSendEmail(!showSendEmail);
  };

  const PostDefaultMail = useCallback(async (id, action, trust_type) => {
    if (id) {
      try {
        setMailLoading(true);
        const { data } = await get(
          `${API.CONTRACTOR_DETAILS}/mail?id=${id}&send_email=1&trust_type=${
            trust_type == 0 ? "0" : trust_type ? trust_type : trustType
          }`
        );
        setShowSendEmail(false);
        fetchContractors();
        data?.message && toast.success(data?.message);
        setMailLoading(false);
      } catch (error) {
        if (error?.response?.data?.errors) {
          setMailLoading(false);
          Object.keys(error?.response?.data?.errors).forEach((key) => {
            toast.error(error?.response?.data?.errors[key][0]);
          });
        } else {
          setMailLoading(false);
          toast.error(error?.message);
        }
      }
    }
    // eslint-disable-next-line
  }, []);

  const handleSubmit = async (values) => {
    if (id) {
      try {
        setMailLoading(true);
        const formData = new FormData();
        // formData.append("id", id);
        formData.append("type", "subcontractor");
        formData.append("trust_type", trustType);
        formData.append("builder_project_id", projectId);
        for (const key in values) {
          if (key !== "ccChip" && key !== "bccChip") {
            if (key === "cc" || key === "bcc") {
              if (values[key]) {
                let valueData =
                  typeof values[key] === "string"
                    ? values[key]?.replace(/\s*,\s*/g, ",")?.split(",")
                    : values[key];
                for (
                  let valueIndex = 0;
                  valueIndex < valueData?.length;
                  valueIndex++
                ) {
                  formData.append(
                    `${key}[${valueIndex}]`,
                    valueData[valueIndex]
                  );
                }
              }
            } else {
              formData.append(key, values[key]);
            }
          }
        }
        files.forEach((file, index) => {
          formData.append(`attachments[${index}]`, file);
        });
        const { data } = await fileUpload(
          `${API.SEND_EMAIL_DOCS}/${id}`,
          formData
        );
        setShowSendEmail(false);
        fetchContractors();
        data?.message && toast.success(data?.message);
        setMailLoading(false);
      } catch (error) {
        if (error?.response?.data?.errors) {
          setMailLoading(false);
          Object.keys(error?.response?.data?.errors).forEach((key) => {
            toast.error(error?.response?.data?.errors[key][0]);
          });
        } else {
          setMailLoading(false);
          toast.error(error?.message);
        }
      }
    }
  };

  const renderDateBoxes = (date = "") => {
    if (date) {
      const day = date.getDate().toString().padStart(2, "0").split("");
      const month = (date.getMonth() + 1).toString().padStart(2, "0").split("");
      const year = date.getFullYear().toString().split("");
      const dateArray = [...day, "", ...month, "", ...year];

      return dateArray.map((char, idx) =>
        char === "" ? (
          <td
            key={idx}
            style={{
              width: "15px",
              paddingLeft: "8px",
              paddingRight: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            /
          </td>
        ) : (
          <td
            key={idx}
            style={{
              border: "1px solid #000",
              width: "20px",
              height: "20px",
              textAlign: "center",
            }}
          >
            {char}
          </td>
        )
      );
    } else {
      const dateArray = ["D", "D", "", "M", "M", "", "Y", "Y", "Y", "Y"];

      return dateArray.map((char, idx) =>
        char === "" ? (
          <td
            key={idx}
            style={{
              width: "15px",
              paddingLeft: "8px",
              paddingRight: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            /
          </td>
        ) : (
          <td
            key={idx}
            style={{
              border: "1px solid #000",
              width: "20px",
              height: "20px",
              textAlign: "center",
            }}
          ></td>
        )
      );
    }
  };

  return (
    <>
      <span
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CustomTooltip message={"View"}>
          <span>
            <FontAwesomeIcon
              onClick={toggleShowModal}
              icon={faEye}
              size="1x"
              data-toggle="modal"
              data-target="#contractorDetail"
            />
          </span>
        </CustomTooltip>
        {/* <span></span>&nbsp;&nbsp;/&nbsp;&nbsp;
        <CustomTooltip message={"Template View"}>
          <span>
            <FontAwesomeIcon
              onClick={toggleTemplateModal}
              icon={faEnvelopeOpenText}
              size="1x"
              data-toggle="modal"
              data-target="#contractorDetail"
            />
          </span>
        </CustomTooltip> */}
        {!ProjectReadOnly && (
          <>
            <span></span>&nbsp;&nbsp;/&nbsp;&nbsp;
            <CustomTooltip message={"Edit"}>
              <span>
                <a href={`/projects/${projectId}/sub-contractors/edit/${id}`}>
                  <FontAwesomeIcon icon={faEdit} size="1x" />
                </a>
              </span>
            </CustomTooltip>
            {/* {email ? (
              <CustomTooltip message={"Email"}>
                <span>
                  <FontAwesomeIcon
                    icon={faEnvelope}
                    size="1x"
                    onClick={() => {
                      !record?.is_reversed && handleSendEmail(record?.id);
                    }}
                    className={record?.mail_sent ? "email-sent" : ""}
                    disabled={record?.is_reversed ? true : false}
                  />
                </span>
              </CustomTooltip>
            ) : (
              <CustomTooltip message={"Email address missing"}>
                <span>
                  <FontAwesomeIcon
                    icon={faEnvelope}
                    size="1x"
                    disabled
                    // style={{ pointerEvents: "none" }}
                    className="disabled-font-awesome"
                  />
                </span>
              </CustomTooltip>
            )} */}
          </>
        )}
        {!ProjectReadOnly &&
          ProjectData?.subscription?.plan_with_contacts &&
          (email ? (
            <>
              <span></span>&nbsp;&nbsp;/&nbsp;&nbsp;
              <CustomTooltip message={"Invite"}>
                <span>
                  <FontAwesomeIcon
                    icon={faPaperPlane}
                    size="1x"
                    onClick={() => toggleShowInvite()}
                    className={is_invited ? "rag-green" : ""}
                  />
                </span>
              </CustomTooltip>
            </>
          ) : (
            <>
              <span></span>&nbsp;&nbsp;/&nbsp;&nbsp;
              <CustomTooltip message={"Please enter email for invite"}>
                <span>
                  <FontAwesomeIcon
                    icon={faPaperPlane}
                    size="1x"
                    className="disabled-font-awesome"
                    disabled
                  />
                </span>
              </CustomTooltip>
            </>
          ))}
        {!ProjectReadOnly &&
          (xeroConnection ? (
            <>
              <span></span>&nbsp;&nbsp;/&nbsp;&nbsp;
              <CustomTooltip message={"Sync"}>
                <span>
                  <FontAwesomeIcon
                    icon={faSync}
                    size="1x"
                    onClick={() => toggleSingleSyncOptionModal(id)}
                  />
                </span>
              </CustomTooltip>
            </>
          ) : (
            <>
              <span></span>&nbsp;&nbsp;/&nbsp;&nbsp;
              <CustomTooltip message={"Please connect with xero to sync."}>
                <span>
                  <FontAwesomeIcon
                    icon={faSync}
                    size="1x"
                    className="disabled-font-awesome"
                    disabled
                    onClick={() => toggleSingleSyncOptionModal(id)}
                  />
                </span>
              </CustomTooltip>
            </>
          ))}
        {!used && (
          <>
            <span></span>&nbsp;&nbsp;/&nbsp;&nbsp;
            <FontAwesomeIcon
              onClick={toggleDeleteModal}
              icon={faTrash}
              size="1x"
              data-toggle="modal"
              data-target="#deleteContractor"
            />
          </>
        )}
        <>
          <span></span>&nbsp;&nbsp;/&nbsp;&nbsp;
          <CustomTooltip message={"Trust Notice"}>
            <span className="more-action">
              <Dropdown>
                <Dropdown.Toggle
                  id="dropdown-basic"
                  style={{
                    padding: "0px",
                    background: "none",
                    color: "black",
                  }}
                >
                  <FontAwesomeIcon icon={faEllipsisVertical} />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item
                    style={{
                      width: "100%",
                    }}
                    onClick={() => toggleTemplateModal(1)}
                  >
                    PTA Notice View
                  </Dropdown.Item>
                  {email && (
                    <Dropdown.Item
                      style={{
                        width: "100%",
                      }}
                      onClick={() => handleSendEmail(record?.id, 1)}
                    >
                      PTA Notice Email
                    </Dropdown.Item>
                  )}

                  <Dropdown.Item
                    style={{
                      width: "100%",
                    }}
                    onClick={() => toggleTemplateModal(0)}
                  >
                    RTA Notice View
                  </Dropdown.Item>
                  {email && (
                    <Dropdown.Item
                      style={{
                        width: "100%",
                      }}
                      onClick={() => handleSendEmail(record?.id, 0)}
                    >
                      RTA Notice Email
                    </Dropdown.Item>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </span>
          </CustomTooltip>
        </>
      </span>

      {showTemplate && (
        <Modal
          size="lg"
          show={showTemplate}
          onHide={toggleTemplateModal}
          dialogClassName="small-review payment-schedule-calender-modal subcontractor-modal"
          aria-labelledby="contained-modal-title-vcenter"
          className="project-section"
          centered
        >
          <Modal.Header className="mb-0" closeButton>
            {trustType === 1 ? "PTA Notice" : "RTA Notice"}
            <PrintButton />
          </Modal.Header>
          <Modal.Body>
            <div id="print">
              {trustType === 1 ? (
                <div
                  style={{
                    fontFamily: "Arial, sans-serif",
                    margin: "20px",
                    fontSize: "14px",
                    color: "#000",
                  }}
                >
                  {/* HEADER */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    {record?.project?.builder?.logo ? (
                      <img
                        src={record?.project?.builder?.logo}
                        style={{ height: "100px", width: "auto" }}
                        alt=""
                      />
                    ) : record?.project?.builder?.builder_details
                        ?.profile_pic ? (
                      <img
                        src={
                          record?.project?.builder?.builder_details?.profile_pic
                        }
                        style={{ height: "100px", width: "auto" }}
                        alt=""
                      />
                    ) : (
                      <div>{record?.project?.builder?.business_name}</div>
                    )}
                    <div
                      style={{
                        textAlign: "right",
                      }}
                    >
                      <div
                        style={{
                          fontSize: "20px",
                          fontWeight: "bold",
                          color: "#009fe3",
                        }}
                      >
                        TRUST ACCOUNT NOTICE
                      </div>
                      <div style={{ fontSize: "14px", color: "#009fe3" }}>
                        (TO CONTRACTING PARTY)
                      </div>
                    </div>
                  </div>

                  <hr
                    style={{
                      margin: "20px 0",
                    }}
                  />

                  {/* Intro Text */}
                  <div style={{ fontWeight: "bold", marginBottom: "10px" }}>
                    NOTICE OF PROJECT TRUST ACCOUNT TO BE USED FOR PROJECT
                    (S18B)
                  </div>
                  <div style={{ marginBottom: "10px" }}>
                    Under the{" "}
                    <em>
                      Building Industry Fairness (Security of Payment) Act 2017
                    </em>{" "}
                    a project trust account is required to be used on certain
                    projects for all payments to subcontractors.
                  </div>
                  <div style={{ marginBottom: "20px" }}>
                    You have received this notice as part of the trustee’s legal
                    obligation to inform you, as a contracting party, of the
                    establishment of a project trust account.
                  </div>

                  {/* SECTION: IMPORTANT INFORMATION */}
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      marginBottom: "20px",
                    }}
                  >
                    <tbody>
                      <tr>
                        <td
                          colSpan={2}
                          style={{
                            backgroundColor: "#f2f2f2",
                            fontWeight: "bold",
                            padding: "8px",
                            border: "1px solid #ccc",
                          }}
                        >
                          IMPORTANT INFORMATION
                        </td>
                      </tr>
                      <tr>
                        <td style={{ padding: "10px", width: "60px" }}>To:</td>
                        <td
                          style={{
                            borderBottom: "1px solid #000",
                            padding: "10px",
                          }}
                        >
                          {formatSubcontractorName(record)}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  {/* PART A */}
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      marginBottom: "20px",
                    }}
                  >
                    <tbody>
                      <tr>
                        <td
                          colSpan={2}
                          style={{
                            backgroundColor: "#f2f2f2",
                            fontWeight: "bold",
                            padding: "8px",
                            border: "1px solid #ccc",
                          }}
                        >
                          PART A – CONTRACT DESCRIPTION
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2} style={{ padding: "10px" }}>
                          The project trust account detailed below has been
                          opened for the (project description):
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan={2}
                          style={{
                            border: "1px solid #ccc",
                            height: "60px",
                            padding: "10px",
                          }}
                        >
                          {record?.project?.project_name}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ padding: "10px", width: "110px" }}>
                          Site address:
                        </td>
                        <td
                          style={{
                            borderBottom: "1px solid #000",
                            padding: "10px",
                          }}
                        >
                          {formatedAddress(
                            record?.project?.street,
                            record?.project?.suburb?.name,
                            record?.project?.state?.short_name,
                            record?.project?.postal_code
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2} style={{ padding: "10px" }}>
                          All payments for the contract are to be paid into this
                          project trust account.
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  {/* PART B */}
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      marginBottom: "20px",
                    }}
                  >
                    <tbody>
                      <tr>
                        <td
                          colSpan={2}
                          style={{
                            backgroundColor: "#f2f2f2",
                            fontWeight: "bold",
                            padding: "8px",
                            border: "1px solid #ccc",
                          }}
                        >
                          PART B – PROJECT TRUST ACCOUNT DETAILS
                        </td>
                      </tr>
                      {[
                        {
                          label: "Trustee’s full name:",
                          value:
                            record?.project?.trustee_contractor?.business_name,
                        },
                        {
                          label: "Account name:",
                          value: record?.project?.pta_contractor?.account_name,
                        },
                        {
                          label: "Financial institution name:",
                          value: record?.project?.pta_contractor?.bank?.name,
                        },
                        {
                          label: "BSB:",
                          value: formatBSBNumber(
                            record?.project?.pta_contractor?.bsb
                          ),
                        },
                        {
                          label: "Account number:",
                          value: formatAccountNumber(
                            record?.project?.pta_contractor?.account_number
                          ),
                        },
                      ].map((item, i) => (
                        <tr key={i}>
                          <td
                            style={{
                              padding: "10px",
                              width: "180px",
                            }}
                          >
                            {item?.label}
                          </td>
                          <td
                            style={{
                              borderBottom: "1px solid #000",
                              padding: "10px",
                            }}
                          >
                            {item?.value}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  {/* PART C */}
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      marginBottom: "20px",
                    }}
                  >
                    <tbody>
                      <tr>
                        <td
                          colSpan={2}
                          style={{
                            backgroundColor: "#f2f2f2",
                            fontWeight: "bold",
                            padding: "8px",
                            border: "1px solid #ccc",
                          }}
                        >
                          PART C – AUTHORISATION
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            padding: "10px",
                            width: "180px",
                          }}
                        >
                          Signed:
                        </td>
                        <td
                          style={{
                            borderBottom: "1px solid #000",
                            padding: "10px",
                          }}
                        >
                          {
                            record?.project?.trustee_contractor
                              ?.trustee_director
                          }
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            padding: "10px",
                            width: "180px",
                          }}
                        >
                          Signatory’s full name:
                        </td>
                        <td
                          style={{
                            borderBottom: "1px solid #000",
                            padding: "10px",
                          }}
                        >
                          {
                            record?.project?.trustee_contractor
                              ?.trustee_director
                          }
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            padding: "10px",
                            width: "180px",
                          }}
                        >
                          Date:
                        </td>
                        <td style={{ padding: "10px" }}>
                          <table style={{ borderCollapse: "collapse" }}>
                            <tbody>
                              <tr>
                                {(() => {
                                  const now = new Date();
                                  const day = now
                                    .getDate()
                                    .toString()
                                    .padStart(2, "0")
                                    .split("");
                                  const month = (now.getMonth() + 1)
                                    .toString()
                                    .padStart(2, "0")
                                    .split("");
                                  const year = now
                                    .getFullYear()
                                    .toString()
                                    .split("");

                                  const dateArray = [
                                    ...day,
                                    "",
                                    ...month,
                                    "",
                                    ...year,
                                  ];

                                  return dateArray.map((char, idx) =>
                                    char === "" ? (
                                      <td
                                        key={idx}
                                        style={{
                                          width: "15px",
                                          paddingLeft: "8px",
                                          paddingRight: "8px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        /
                                      </td>
                                    ) : (
                                      <td
                                        key={idx}
                                        style={{
                                          border: "1px solid #000",
                                          width: "20px",
                                          height: "20px",
                                          textAlign: "center",
                                        }}
                                      >
                                        {char}
                                      </td>
                                    )
                                  );
                                })()}
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  {/* FOOTER */}
                  <div
                    style={{
                      fontSize: "12px",
                      fontWeight: "bold",
                      paddingBottom: "15px",
                    }}
                  >
                    Please note this form is for your record of notification and
                    is not to be returned to the QBCC.
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    fontFamily: "Arial, sans-serif",
                    margin: "20px",
                    fontSize: "14px",
                    color: "#000",
                  }}
                >
                  {/* HEADER */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    {record?.project?.builder?.logo ? (
                      <img
                        src={record?.project?.builder?.logo}
                        style={{ height: "100px", width: "auto" }}
                        alt=""
                      />
                    ) : record?.project?.builder?.builder_details
                        ?.profile_pic ? (
                      <img
                        src={
                          record?.project?.builder?.builder_details?.profile_pic
                        }
                        style={{ height: "100px", width: "auto" }}
                        alt=""
                      />
                    ) : (
                      <div>{record?.project?.builder?.business_name}</div>
                    )}
                    <div
                      style={{
                        textAlign: "right",
                      }}
                    >
                      <div
                        style={{
                          fontSize: "20px",
                          fontWeight: "bold",
                          color: "#009fe3",
                        }}
                      >
                        TRUST ACCOUNT NOTICE
                      </div>
                      <div style={{ fontSize: "14px", color: "#009fe3" }}>
                        (TO CONTRACTED PARTY)
                      </div>
                    </div>
                  </div>

                  <hr
                    style={{
                      margin: "20px 0",
                    }}
                  />

                  {/* Intro */}
                  <div style={{ fontWeight: "bold", marginBottom: "10px" }}>
                    NOTICE OF RETENTION TRUST TO BE USED FOR CONTRACT (S34B)
                    <br />
                    NOTICE OF TRANSFER OF RETENTION TRUST TO ANOTHER FINANCIAL
                    INSTITUTION (S34C)
                  </div>
                  <div style={{ marginBottom: "10px" }}>
                    Under the{" "}
                    <em>
                      Building Industry Fairness (Security of Payment) Act 2017
                    </em>
                    , a retention trust account is required to hold certain cash
                    retentions withheld from subcontractors under building
                    contracts.
                  </div>
                  <div style={{ marginBottom: "20px" }}>
                    You have received this notice as part of the trustee’s legal
                    obligation to inform you, as a contracted party, of the
                    establishment or transfer of a retention trust account to
                    another financial institution.
                  </div>

                  {/* SECTION: RETENTION INFO */}
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      marginBottom: "20px",
                    }}
                  >
                    <tbody>
                      <tr>
                        <td
                          colSpan={2}
                          style={{
                            backgroundColor: "#f2f2f2",
                            fontWeight: "bold",
                            padding: "8px",
                            border: "1px solid #ccc",
                          }}
                        >
                          IMPORTANT INFORMATION ABOUT RETENTION AMOUNTS
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            padding: "10px",
                            width: "210px",
                          }}
                        >
                          Contracting party’s full name:
                        </td>
                        <td
                          style={{
                            borderBottom: "1px solid #000",
                            padding: "10px",
                          }}
                        >
                          {formatSubcontractorName(record)}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2} style={{ padding: "10px" }}>
                          Any cash retentions withheld and affecting any
                          retention amount will be stored in the contract
                          detailed below.
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  {/* PART A */}
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      marginBottom: "20px",
                    }}
                  >
                    <tbody>
                      <tr>
                        <td
                          colSpan={2}
                          style={{
                            backgroundColor: "#f2f2f2",
                            fontWeight: "bold",
                            padding: "8px",
                            border: "1px solid #ccc",
                          }}
                        >
                          PART A – CONTRACT DESCRIPTION
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            padding: "10px",
                            width: "200px",
                          }}
                        >
                          Project Name/Description:
                        </td>
                        <td
                          style={{
                            borderBottom: "1px solid #000",
                            padding: "10px",
                          }}
                        >
                          {record?.project?.project_name}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  {/* PART B */}
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      marginBottom: "20px",
                    }}
                  >
                    <tbody>
                      <tr>
                        <td
                          colSpan={2}
                          style={{
                            backgroundColor: "#f2f2f2",
                            fontWeight: "bold",
                            padding: "8px",
                            border: "1px solid #ccc",
                          }}
                        >
                          PART B – RETENTION TRUST DETAILS
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2} style={{ padding: "10px" }}>
                          Complete Part B only if a new retention trust has been
                          newly opened, or in the case of an account transfer,
                          to advise of the updated account information.
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            padding: "10px",
                            width: "200px",
                          }}
                        >
                          Account name:
                        </td>
                        <td
                          style={{
                            borderBottom: "1px solid #000",
                            padding: "10px",
                          }}
                        >
                          {record?.project?.rta_contractor?.account_name}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            padding: "10px",
                            width: "200px",
                          }}
                        >
                          BSB:
                        </td>
                        <td
                          style={{
                            borderBottom: "1px solid #000",
                            padding: "10px",
                          }}
                        >
                          {record?.project?.rta_contractor?.bsb}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            padding: "10px",
                            width: "200px",
                          }}
                        >
                          Account number:
                        </td>
                        <td
                          style={{
                            borderBottom: "1px solid #000",
                            padding: "10px",
                          }}
                        >
                          {record?.project?.rta_contractor?.account_number}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  {/* PART C */}
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      marginTop: "20px",
                      marginBottom: "20px",
                    }}
                  >
                    <tbody>
                      <tr>
                        <td
                          colSpan={2}
                          style={{
                            backgroundColor: "#f2f2f2",
                            fontWeight: "bold",
                            padding: "8px",
                            border: "1px solid #ccc",
                          }}
                        >
                          PART C – PREVIOUS TRUST ACCOUNT DETAILS AND RELEVANT
                          DATES
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2} style={{ padding: "10px" }}>
                          Complete Part C only if the account detailed in Part B
                          above is a new account opened as part of an account
                          transfer from an alternate financial institution.
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            padding: "10px",
                            width: "200px",
                          }}
                        >
                          Account name:
                        </td>
                        <td
                          style={{
                            borderBottom: "1px solid #000",
                            padding: "10px",
                          }}
                        ></td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            padding: "10px",
                            width: "200px",
                          }}
                        >
                          BSB:
                        </td>
                        <td
                          style={{
                            borderBottom: "1px solid #000",
                            padding: "10px",
                          }}
                        ></td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            padding: "10px",
                            width: "200px",
                          }}
                        >
                          Account number:
                        </td>
                        <td
                          style={{
                            borderBottom: "1px solid #000",
                            padding: "10px",
                          }}
                        ></td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            padding: "10px",
                            width: "200px",
                          }}
                        >
                          Date of transfer:
                        </td>
                        <td style={{ padding: "10px" }}>
                          <table style={{ borderCollapse: "collapse" }}>
                            <tbody>
                              <tr>{renderDateBoxes()}</tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            padding: "10px",
                            width: "200px",
                          }}
                        >
                          Date funds were deposited:
                        </td>
                        <td style={{ padding: "10px" }}>
                          <table style={{ borderCollapse: "collapse" }}>
                            <tbody>
                              <tr>{renderDateBoxes()}</tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  {/* PART D */}
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      marginBottom: "20px",
                    }}
                  >
                    <tbody>
                      <tr>
                        <td
                          colSpan={2}
                          style={{
                            backgroundColor: "#f2f2f2",
                            fontWeight: "bold",
                            padding: "8px",
                            border: "1px solid #ccc",
                          }}
                        >
                          PART D – AUTHORISATION
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            padding: "10px",
                            width: "200px",
                          }}
                        >
                          Signed:
                        </td>
                        <td
                          style={{
                            borderBottom: "1px solid #000",
                            padding: "10px",
                          }}
                        >
                          {
                            record?.project?.trustee_contractor
                              ?.trustee_director
                          }
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            padding: "10px",
                            width: "200px",
                          }}
                        >
                          Signatory’s full name:
                        </td>
                        <td
                          style={{
                            borderBottom: "1px solid #000",
                            padding: "10px",
                          }}
                        >
                          {
                            record?.project?.trustee_contractor
                              ?.trustee_director
                          }
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            padding: "10px",
                            width: "200px",
                          }}
                        >
                          Date:
                        </td>
                        <td style={{ padding: "10px" }}>
                          <table style={{ borderCollapse: "collapse" }}>
                            <tbody>
                              <tr>{renderDateBoxes(new Date())}</tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  {/* FOOTER */}
                  <div
                    style={{
                      fontSize: "12px",
                      fontWeight: "bold",
                      paddingBottom: "15px",
                    }}
                  >
                    Please note this form is for your record of notification and
                    is not to be returned to the QBCC.
                  </div>
                </div>
              )}
            </div>
          </Modal.Body>
        </Modal>
      )}

      {showDelete && (
        <SubContractorDelete
          contractorId={id}
          toggleDeleteModal={toggleDeleteModal}
          handleDelete={handleDelete}
          showDelete={showDelete}
        />
      )}

      {showView && (
        <SubContractorDetailsPopup
          contractorId={id}
          toggleShowModal={toggleShowModal}
          showView={showView}
        />
      )}

      {showInvite && (
        <Modal
          size="lg"
          show={showInvite}
          onHide={toggleShowInvite}
          dialogClassName="modal-50w small-popup review-popup small-review"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header className="mb-0" closeButton>
            Invite Subcontractor
          </Modal.Header>
          <Modal.Body>
            {loading && <Spin />}
            <div className="modal-body">
              Are your sure you want to invite this subcontractor?
            </div>
            <div className="modal-footer">
              <Button
                type="Button"
                className="btn btn-secondary"
                onClick={() => {
                  toggleShowInvite();
                }}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                className="btn btn-primary"
                data-dismiss="modal"
                onClick={() => {
                  handleInvite();
                }}
              >
                OK
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      )}

      {showSendEmail && (
        <Modal
          size="lg"
          show={showSendEmail}
          onHide={() => {
            handleSendEmail();
          }}
          dialogClassName="modal-50w small-popup review-popup small-review"
          aria-labelledby="contained-modal-title-vcenter"
          className="project-section"
          centered
        >
          <Modal.Header className="mb-0" closeButton>
            Send Email
          </Modal.Header>
          <Modal.Body>
            {mailLoading && <Spin />}
            <AdditionalDocumentEmailModal
              defaultContent={
                <>
                  <div className="modal-body">
                    {/* Are you sure you want to resend email of payment schedule? */}
                    Do you want to send the notice via email?
                  </div>
                  <div className="modal-footer">
                    <Button
                      type="submit"
                      className="btn btn-primary"
                      data-dismiss="modal"
                      onClick={() => {
                        PostDefaultMail(id, "email", trustType);
                      }}
                    >
                      Yes
                    </Button>
                    <Button
                      type="Button"
                      className="btn btn-secondary"
                      onClick={() => {
                        handleSendEmail();
                      }}
                    >
                      No
                    </Button>
                  </div>
                </>
              }
              handleSubmit={handleSubmit}
              setFiles={setFiles}
              files={files}
              toggleCancel={handleSendEmail}
              mailData={mailData}
              type={"subcontractor"}
            />
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default SubContractorActionButton;
